module.exports = __webpack_public_path__ + "static/flutter-7ba04b9e729025dfa92d0f5d4e8d34a4.png";